/* @ngInject */
function SmartVaultFactory($http, $rootScope, Organization) {
  class SmartVault {
    static integrate(email) {
      return $http
        .post(`${process.env.SERVER_URL}/api/secure/smartvault/integrate`, {
          email,
        })
        .then((response) => response.data);
    }

    static removeIntegration() {
      return $http
        .delete(`${process.env.SERVER_URL}/api/secure/smartvault/integration`)
        .then((response) => response.data);
    }

    static integrated() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/smartvault/integrated`)
        .then((response) => response.data);
    }

    static getAccounts() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/smartvault/accounts`)
        .then((response) => response.data);
    }

    static getAccountClients(inputValue) {
      return $http
        .get(
          `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/smartvault/clients`,
          {
            params: { search: inputValue },
          }
        )
        .then((response) => response.data);
    }

    static getClientContacts(clientId) {
      return $http
        .get(
          `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/smartvault/clients/${clientId}/contacts`
        )
        .then((response) => response.data);
    }

    static getClient(clientId) {
      return $http
        .get(
          `${process.env.SERVER_URL}/api/secure/organization/${$rootScope.organization.slug}/smartvault/clients/${clientId}`
        )
        .then((response) => response.data);
    }

    static createProposal(accountId, clientId) {
      return $http
        .post(
          `${process.env.SERVER_URL}/api/secure/smartvault/create-proposal`,
          { fid: accountId, cid: clientId }
        )
        .then((response) => response.data);
    }

    static syncOrganizations() {
      return $http
        .get(`${process.env.SERVER_URL}/api/secure/smartvault/organizations`)
        .then((response) =>
          response.data.map((organization) =>
            organization.integrationFailed
              ? organization
              : new Organization(organization)
          )
        );
    }
  }

  return SmartVault;
}

export default SmartVaultFactory;
